import { QueryFileUpload } from '@/components/connectors/QueryFileUpload';
import type { ConnectorType, QueryFile } from '@/types/connectors';

interface Props {
  connectorType: string;
  value: QueryFile | null;
  onChange: (v: QueryFile | null) => void;
  disabled: boolean;
}

export function QueriesField({ connectorType, value, onChange, disabled }: Props) {
  return (
    <QueryFileUpload
      connectorType={connectorType as ConnectorType}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="border-0 shadow-none"
    />
  );
}
